// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'object-case-solid';

export const Component = () => (
  <g fill='currentColor'>
    <path d='M25 18.523 19.853 25H8l4.191-6.477L8 12h11.852z' />
    <path d='M8.906 2c.516 0 .797.232.89.651l.75 2.236h12.516a.93.93 0 0 1 .657.28c.187.186.281.42.281.651v8.208L20.822 10H4.338l5.473 8.519L6.91 23H.937a.93.93 0 0 1-.656-.28.918.918 0 0 1-.281-.652V2.978c0-.233.094-.466.281-.699A.93.93 0 0 1 .937 2z' />
  </g>
);

export const viewBox = '0 0 25 25';
